export enum BiofuelGrade {
    'B10' = 1,
    'B20' = 2,
    'B24' = 3,
    'B30' = 4,
    'B50' = 5,
    'B100' = 6,
}

export const getBiofuelGradeId = (biofuelGrade: BiofuelGrade): number | undefined => {
    return BiofuelGrade[biofuelGrade as unknown as keyof typeof BiofuelGrade];
};

export const getBiofuelGrade = (biofuelGradeId: number): BiofuelGrade | undefined => {
    return BiofuelGrade[biofuelGradeId as unknown as keyof typeof BiofuelGrade];
};
